import { memo, useEffect, useMemo, useState } from "react";

import iconChevron26 from "../../assets/images/chervon-26.svg";
import iconGrid from "../../assets/images/close.svg";
import expandScaleIcon from "../../assets/images/scale-up.svg";
import { useGlobal } from "../../contexts/globalContext";
import { useJanusContext } from "../../contexts/janus/JanusContext";
import { useScreenFlowController } from "../../hooks/useJanus/screenFlowController/useScreenFlowController";
import { useOSIcons } from "../../hooks/useOSIcons";

export const selectScreen = (_SET_SCREEN_STATE, id) => {
  _SET_SCREEN_STATE((prevState) => ({
    ...prevState,
    currentScreen: {
      ...prevState.currentScreen,
      id,
      state: "switching",
    },
  }));
};

export const ScreenList = memo(() => {
  const { SCREEN_STATE, SET_SCREEN_STATE, SET_GRID_STATE } = useGlobal();
  const { StreamingPlugin, oldScreensArray } = useJanusContext();
  useScreenFlowController();

  const [screenDropDownToggle, setScreenDropDownToggle] = useState(false);

  const filteredScreens = useMemo(() => oldScreensArray?.filter((x) => x.id > 0), [oldScreensArray]);

  const { osIcons, fetchOsIcons } = useOSIcons(oldScreensArray || []);

  useEffect(() => {
    fetchOsIcons(filteredScreens);
  }, [filteredScreens]);

  const handleSelectScreen = (screen) => {
    if (StreamingPlugin.current) {
      if (SCREEN_STATE.currentScreen.id !== screen.id) selectScreen(SET_SCREEN_STATE, screen.id);
    } else console.log("🚩 'StreamingPlugin.current' is null.");
  };

  const handleGridClick = () => {
    SET_GRID_STATE((p) => ({
      ...p,
      isActive: !p.isActive,
    }));
  };

  const getCurrentScreenResolution = () => {
    const currentScreen = oldScreensArray.find((x) => x.id === SCREEN_STATE.currentScreen.id);

    return currentScreen ? `${currentScreen.res[2]}x${currentScreen.res[2]}` : null;
  };

  const getCurrentScreenName = () => {
    const currentScreen = oldScreensArray.find((x) => x.id === SCREEN_STATE.currentScreen.id);

    return currentScreen ? currentScreen.name : null;
  };

  if (oldScreensArray?.length === 0 || SCREEN_STATE.currentScreen.id === null) {
    console.log("🚩 'oldScreensArray.length === 0 || SCREEN_STATE.currentScreen.id === null' is null.");

    return null;
  }

  return (
    <div className={`dropdown ${screenDropDownToggle ? "toggle" : ""}`} id="screens-dropdown">
      <div className="dropbtn">
        <div className="dropbtn-contaner active-screen">
          <div className="flex h-30">
            <div className="dropdown-os-info">
              <img src={osIcons[SCREEN_STATE.currentScreen.id]} alt="os" />
              <span className="os-resolution small-font">{getCurrentScreenResolution()}</span>
              <span className="change-scale">
                <img src={expandScaleIcon} alt="scale" className="btn-12 btn-scale-size" />
              </span>
            </div>
            <div className="dropdown-screen-info">
              <span className="screen-number">Screen {SCREEN_STATE.currentScreen.id}</span>
              <span className="screen-os"> {getCurrentScreenName()}</span>
            </div>
          </div>
          <div className="flex p-3" onClick={() => setScreenDropDownToggle(!screenDropDownToggle)}>
            <div id="progressbar" className="progressbar hide" />
            <img src={iconChevron26} alt="chevronDown" className="btn-26 chervon-small z-index-1" />
          </div>
          <div className="flex p-3" onClick={handleGridClick}>
            <div id="progressbar" className="progressbar hide" />
            <img src={iconGrid} alt="chevronDown" className="btn-16 chervon-small z-index-1" />
          </div>
        </div>
        <div className="dropdown-content">
          {oldScreensArray
            .filter((x) => x.id > 0)
            .map((screen) => (
              <div
                key={screen.id}
                className="dropdown-content-item"
                data-name={screen.name}
                id={`screen-${screen.name}`}
                onClick={() => handleSelectScreen(screen)}>
                <div className="dropbtn-contaner">
                  <div className="flex h-30">
                    <div className="dropdown-os-info">
                      <img src={osIcons[screen.id]} alt="os" className="icon-os" />
                      <span className="os-resolution small-font">
                        {screen.res[2]}x{screen.res[3]}
                      </span>
                      <span className="change-scale">
                        <img src={expandScaleIcon} alt="scale" className="btn-12 btn-scale-size" />
                      </span>
                    </div>
                    <div className="dropdown-screen-info">
                      <span> Screen {screen.id} </span>
                      <span>
                        {screen.name} ({screen.os})
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
});
